export const COUPON_QUERY_KEY = 'coupon-code';
